import { createStoreCreator } from 'lib/store'
import reducer from 'reports/production/reducers'

export default createStoreCreator(reducer)
